<template>
  <div class="case">
    <div class="banner">
      <img :src="currentLg.banner" alt="" />
    </div>
    <div class="main">
      <div class="main-contents">
        <el-tabs v-model="params.type" @tab-click="getList">
          <el-tab-pane
            v-for="(i, index) in typeList"
            :key="index"
            :label="i[`name_${locale}`]"
            :name="i.id + ''"
          ></el-tab-pane>
        </el-tabs>
        <ul class="case-contnet">
          <li v-for="(item, index) in list" :key="index">
            <div class="case-img">
              <img :src="item.imgUrl" />
            </div>
            <div class="case-contain">
              <div class="case-content">
                <p class="case-name">
                  <span>{{ locale == "CN" ? item.title : item.titleEn }}</span>
                </p>
                <div class="case-cn">
                  <div v-show="locale == 'CN'" v-html="item.desc"></div>
                  <div v-show="locale == 'EN'" v-html="item.descEn"></div>
                </div>
              </div>

              <img
                v-show="locale == 'CN'"
                class="more-icon icon-cn"
                @click="more(item.id, item.type, index)"
                src="./../assets/images/case/more-m-cn.png"
                alt=""
              />
              <img
                v-show="locale == 'EN'"
                class="more-icon icon-en"
                @click="more(item.id, item.type, index)"
                src="./../assets/images/case/more-m-en.png"
                alt=""
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import language from "./../language/case/index";
export default {
  data() {
    return {
      list: [
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn:
            "<p>Over 10 million kWh annual saving of electricityOver 10 million kWh annual saving of electricityOver 10 million kWh annual saving of electricityOver 10 million kWh annual saving of electricity</p>",
          id: 26,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇",
          titleEn: "TaiKoo Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 26,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇1",
          titleEn: "TaiKoo Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
        {
          createDate: 1691396256000,
          desc: "<p>年节电超1000万+kWh，20年超2亿kWh；</p>",
          descEn: "<p>Over 10 million kWh annual saving of electricity</p>",
          id: 26,
          imgUrl:
            "http://resource.jmjnsz.com/jmjn-portal/2023/08/07/d45a3181-604a-4244-a7ee-4d520794562e.png",
          title: "广州太古汇2",
          titleEn: "TaiKoo Hui Guangzhou ",
          type: 1,
          updateDate: 1691566189000,
        },
      ],
      params: {
        pageNo: 1,
        pageSize: 20,
        type: "1",
      },
      totals: 0,
      typeList: [
        {
          name_CN: "商业",
          name_EN: "Commercials",
          id: "1",
        },
        {
          name_CN: "工厂",
          name_EN: "Factories",
          id: "2",
        },
         {
          name_CN: "数据中心",
          name_EN: "Data Center",
          id: "3",
         },
      ],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  watch: {
    locale() {
      window.location.reload();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$http
        .get("/api/portal/project/queryPage", {
          params: this.params,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data && res.data.items ? res.data.items : [];
          this.totals =
            res.data && res.data.page && res.data.page.rowCount
              ? res.data.page.rowCount
              : 0;
        });
    },
    more(id, type, index) {
      this.$router.push({
        path: "/index_m/caseView_m",
        query: { id, type, index },
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-tabs__active-bar {
  background: #1289d9 linear-gradient(90deg, #1289d9, #76dcc7);
}
.el-tabs {
  margin: 1vh 4vw;
}
/deep/ .el-tabs__item {
  font-size: 4vw;
  line-height: 5vh;
  height: 5vh;
}
/deep/ .el-tabs__nav-next,
.el-tabs__nav-prev {
  font-size: 4vw;
  line-height: 5vh;
}
/deep/.el-tabs__nav-scroll {
  overflow: auto;
}
/deep/::-webkit-scrollbar {
  display: none;
}
.case {
  .banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    width: 100vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    .main-contents {
      .case-contnet {
        box-sizing: border-box;
        margin: 0 6vw;
        li {
          padding: 2vh 0;
          border-bottom: 1px dotted #cccccc;
          overflow: hidden;
          .case-img {
            img {
              width: 100%;
              height: 100%;
              border-radius: 2vh;
            }
          }

          .case-contain {
            flex: 1;
            overflow: hidden;
            box-sizing: border-box;
            display: flex;
            align-items: flex-end;
            .case-content {
              flex: 1;
            }
            .case-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              line-height: 6vh;
              span {
                color: #4e4e4e;
                font-size: 4vw;
              }
            }
            .case-cn {
              font-size: 3.5vw;
              color: #4e4e4e;
              div {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* 显示的行数 */
                overflow: hidden;
                text-overflow: ellipsis;
                padding-right: 1vw;
              }
            }
            .more-icon {
              display: flex;
              justify-content: flex-end;
              z-index: 2;
            }
            .icon-cn {
              height: 4vh;
            }
            .icon-en {
              height: 4vh;
            }
          }
        }
      }
      .page {
        text-align: right;
        box-sizing: border-box;
        padding: 30px 0;
        .el-pagination {
          display: inline-block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/case_m.vue